import { useState, useEffect } from "react";
import axios from "axios";
import "./styles/ReportPage.css";
import UserStatus from "../../components/UserStatus";
import search from "/assets/icon/Search.svg";
import DownloadReportWindow from "../../components/DownloadReportWindow";

function ShowbranchesReport() {
  const [searchQuery, setSearchQuery] = useState("");
  const [branchData, setBranchData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchDetails, setBranchDetails] = useState(null);
  const [showDownloadReport, setShowDownloadReport] = useState(false);

  const handleDownloadReportClick = () => {
    setShowDownloadReport(true);
  };

  const handleDownloadReportClose = () => {
    setShowDownloadReport(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSelection = () => {
    setSelectedBranch(null);
    setSearchQuery("");
    setBranchDetails(null);
  };

  useEffect(() => {
    const fetchBranchData = async () => {
      if (searchQuery.trim() === "") {
        setBranchData([]); // Clear branch data if search query is empty
        return;
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/branchSearch?searchQuery=${searchQuery}`
        );
        console.log("Branch Data:", response.data); // Debug log
        setBranchData(response.data);
      } catch (error) {
        console.error("Error fetching branch data:", error);
      }
    };

    fetchBranchData();
  }, [searchQuery]);

  useEffect(() => {
    const fetchBranchDetails = async () => {
      if (!selectedBranch) return;
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/branchCounts/${selectedBranch.id}`
        );
        console.log("Branch Details:", response.data); // Debug log
        setBranchDetails(response.data);
      } catch (error) {
        console.error("Error fetching branch details:", error);
      }
    };

    fetchBranchDetails();
  }, [selectedBranch]);

  const handleBranchClick = (branch) => {
    if (selectedBranch && selectedBranch.id === branch.id) {
      setSelectedBranch(null); // Deselect if clicking the same branch
      setSearchQuery(""); // Clear search query on deselect
      setBranchDetails(null);
    } else {
      setSelectedBranch(branch);
      setSearchQuery(branch.name); // Update search query with selected branch name
    }
  };

  return (
    <div className="showWeatherReport">
      <h1>สาขาทั้งหมดในระบบ SmartPole</h1>

      <h4 className="downloadReport" onClick={handleDownloadReportClick}>
        ดาวน์โหลดรายงาน
      </h4>

      <p>ค้นหาชื่อสาขา, รหัสสาขา</p>
      <div className="searchbarreport">
        <div className="search-bar">
          <img src={search} alt="search" className="search-user" />
          <input
            type="text"
            placeholder="ค้นหาชื่อสาขา, รหัสสาขา"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          {selectedBranch && (
            <button className="clear-button" onClick={handleClearSelection}>
              &times;
            </button>
          )}
        </div>
      </div>
      <div className="searchResults">
        {searchQuery && (
          <>
            {selectedBranch ? (
              <div
                className="resultItem"
                onClick={() => handleBranchClick(selectedBranch)}
                style={{ cursor: "pointer", border: "2px solid #2762F8" }}
              >
                <p>
                  <strong>ชื่อสาขา:</strong> {selectedBranch.name}
                </p>
                <p>
                  <strong>Location:</strong> {selectedBranch.location}
                </p>
                <p>
                  <strong>Latitude:</strong> {selectedBranch.lat},{" "}
                  {selectedBranch.lng}
                </p>
              </div>
            ) : (
              branchData.map((branch) => (
                <div
                  key={branch.id}
                  className="resultItem"
                  onClick={() => handleBranchClick(branch)}
                  style={{ cursor: "pointer" }}
                >
                  <p>
                    <strong>ชื่อสาขา:</strong> {branch.name}
                  </p>
                  <p>
                    <strong>Location:</strong> {branch.location}
                  </p>
                  <p>
                    {branch.lat},{branch.lng}
                  </p>
                </div>
              ))
            )}
          </>
        )}
      </div>
      <hr />
      {branchDetails && (
        <div className="showReportSection">
          <table className="sensorDataTable">
            <thead>
              <tr>
                <th>รหัสสาขา</th>
                <th>ชื่อสาขา</th>
                <th>สถานะ</th>
                <th>ผู้ใช้งาน</th>
                <th>เสาหลัก</th>
                <th>เสารอง</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{selectedBranch.code}</td>
                <td>{selectedBranch.name}</td>
                <td className="w100">
                  <div className="w150">
                    <UserStatus isOnline={branchDetails.branchStatus} />
                  </div>
                </td>
                <td>{branchDetails.usersCount}</td>
                <td>{branchDetails.mainPolesCount}</td>
                <td>{branchDetails.secondaryPolesCount}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {showDownloadReport && (
        <DownloadReportWindow
          onClose={handleDownloadReportClose}
          jsonData={{
            branchInfo: selectedBranch
              ? {
                  code: selectedBranch.code,
                  name: selectedBranch.name,
                  location: selectedBranch.location,
                  latitude: selectedBranch.lat,
                  longitude: selectedBranch.lng,
                }
              : null,
            branchDetails,
          }}
          fileName={
            selectedBranch
              ? `${selectedBranch.name}_branch_report`
              : "branch_report"
          }
          routeName="showbranches"
        />
      )}
    </div>
  );
}

export default ShowbranchesReport;
